module.exports = __webpack_public_path__ + "static/media/1010225909-preview.0822531a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/1010225909-preview.mp4
// module id = 1811
// module chunks = 0